module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "paraNoIndentBB1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Now this is no shit,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There I was, 10,000 feet,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I had a pocket full of nickels and")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There wasn’t a soft drink machine for miles,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So I turned to my copilot and said, ‘Alice,’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When all of a sudden, there was Plexiglass flying everywhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The men, they were scared, but not me.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Down below us we saw a man on a bicycle.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We knew he was going to church,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Because it was Sunday.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So, we rolled in on him.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It was ten to one!")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But we finally got that little SOB”")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentBB",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_vm._v("—Typical flying war story, circa 1971")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5007eab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_dedication.vue
// module id = 69
// module chunks = 0